import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';

const rolConfig = {
  admin:    { label:'Admin',    color:'#f87171' },
  operador: { label:'Operador', color:'#60a5fa' },
  lectura:  { label:'Lectura',  color:'var(--accent)' },
};

export default function Navbar({ usuario, onLogout }) {
  const [tema, setTema] = useState(localStorage.getItem('tema') || 'dark');

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', tema);
    localStorage.setItem('tema', tema);
  }, [tema]);

  const toggleTema = () => setTema(t => t === 'dark' ? 'light' : 'dark');

  const esAdmin = usuario?.rol === 'admin';
  const esOperador = usuario?.rol === 'admin' || usuario?.rol === 'operador';
  const rc = rolConfig[usuario?.rol] || rolConfig.lectura;

  const navStyle = {
    position:'fixed', left:0, top:0, bottom:0, width:'220px',
    background:'var(--bg3)', borderRight:'1px solid var(--border)',
    display:'flex', flexDirection:'column', padding:'1.5rem 0', zIndex:100,
    transition:'background 0.3s'
  };

  const linkStyle = {
    display:'flex', alignItems:'center', gap:'10px',
    padding:'10px 1.25rem', fontSize:'14px', color:'var(--text2)',
    textDecoration:'none', transition:'all 0.15s'
  };

  const activeStyle = {
    color:'var(--accent)',
    background:'var(--accent3)',
    borderLeft:'2px solid var(--accent)'
  };

  return (
    <nav style={navStyle}>
      {/* Brand */}
      <div style={{padding:'0 1.25rem 1.5rem', borderBottom:'1px solid var(--border)', marginBottom:'1rem'}}>
        <div style={{fontSize:'16px', fontWeight:'800', color:'var(--accent)', letterSpacing:'0.5px'}}>
          ⚡ GREEN ENERGY
        </div>
        <div style={{fontSize:'11px', color:'var(--text3)', marginTop:'3px'}}>EV Charge Management</div>
      </div>

      {/* Links */}
      <NavLink to="/" style={({isActive})=>({...linkStyle,...(isActive?activeStyle:{})})} end>🏠 Dashboard</NavLink>
      <NavLink to="/monitor" style={({isActive})=>({...linkStyle,...(isActive?activeStyle:{})})}>📡 Monitor en vivo</NavLink>
      <NavLink to="/historial" style={({isActive})=>({...linkStyle,...(isActive?activeStyle:{})})}>📋 Historial</NavLink>
      {esOperador && <NavLink to="/gestion" style={({isActive})=>({...linkStyle,...(isActive?activeStyle:{})})}>⚙️ Gestión de carga</NavLink>}
      <NavLink to="/alertas" style={({isActive})=>({...linkStyle,...(isActive?activeStyle:{})})}>🚨 Alertas</NavLink>
      <NavLink to="/uptime" style={({isActive})=>({...linkStyle,...(isActive?activeStyle:{})})}>📶 Uptime</NavLink>
      <NavLink to="/diagnostico" style={({isActive})=>({...linkStyle,...(isActive?activeStyle:{})})}>🔬 Diagnóstico</NavLink>
      {esAdmin && <NavLink to="/usuarios" style={({isActive})=>({...linkStyle,...(isActive?activeStyle:{})})}>👥 Usuarios</NavLink>}

      {/* Footer */}
      <div style={{marginTop:'auto', padding:'1rem 1.25rem', borderTop:'1px solid var(--border)'}}>
        {/* Toggle tema */}
        <button onClick={toggleTema}
          style={{width:'100%', padding:'6px', background:'var(--bg)', border:'1px solid var(--border)',
            borderRadius:'6px', color:'var(--text2)', cursor:'pointer', fontSize:'12px', marginBottom:'8px',
            display:'flex', alignItems:'center', justifyContent:'center', gap:'6px'}}>
          {tema==='dark' ? '☀️ Modo claro' : '🌙 Modo oscuro'}
        </button>

        <div style={{fontSize:'12px', color:'var(--text2)', marginBottom:'2px'}}>{usuario?.nombre}</div>
        <div style={{fontSize:'11px', color:rc.color, marginBottom:'8px'}}>{rc.label}</div>
        <button onClick={onLogout}
          style={{width:'100%', padding:'6px', background:'var(--bg)', border:'1px solid var(--border)',
            borderRadius:'6px', color:'var(--text3)', cursor:'pointer', fontSize:'12px'}}>
          → Cerrar sesión
        </button>
      </div>
    </nav>
  );
}
